import React, { FC } from 'react';
import { Box, Container, Grid, Skeleton, useTheme } from '@mui/material';

const AvailableBikesSectionSkeleton: FC = () => {
  const theme = useTheme();

  return (
    <Box py={8}>
      <Container maxWidth="xl">
        {/* Section Title */}
        <Skeleton variant="text" width={250} height={50} sx={{ mb: 4 }} />

        {/* Filter Buttons Skeleton */}
        <Box display="flex" justifyContent='flex-end' gap={2} mb={6}>
          {[...Array(2)].map((_, item) => (
            <Skeleton key={item} variant="rectangular" width={150} height={40} sx={{ borderRadius: 1 }} />
          ))}
        </Box>

        {/* Bikes Grid */}
        <Grid container spacing={4}>
          {[...Array(6)].map((_, item) => (
            <Grid item sm={12} md={6} lg={4} key={item}>
              <Box>
                <Skeleton variant="rectangular" height={200} sx={{ borderRadius: 2 }} />
                <Box mt={2}>
                  <Skeleton variant="text" width="40%" height={20} />
                  <Skeleton variant="text" width="60%" height={30} sx={{ mt: 1 }} />
                  <Skeleton variant="text" width="50%" height={20} />
                  <Skeleton variant="text" width="70%" height={20} />
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export { AvailableBikesSectionSkeleton };